export enum EUserRoles {
  TECH_ADMIN = 1,
  SPACE_ADMIN = 2,
  BASE_USER = 3,
}

export enum EUserScopedRoles {
  EDITOR = 1,
  VIEWER = 2,
  ADMIN = 3,
  SYSTEM_OWNER = 4,
}

export const userRoles: Record<number, string> = {
  [EUserRoles.TECH_ADMIN]: 'Тех. админ',
  [EUserRoles.SPACE_ADMIN]: 'Администратор пространства',
  [EUserRoles.BASE_USER]: 'Пользователь',
};

export const userScopedRoles: Record<number, string> = {
  [EUserScopedRoles.EDITOR]: 'Редактор',
  [EUserScopedRoles.VIEWER]: 'Наблюдатель',
  [EUserScopedRoles.ADMIN]: 'Администратор',
  [EUserScopedRoles.SYSTEM_OWNER]: 'Владелец системы',
};
